import { NotificationType } from 'features/notifications/notifications.types';
import { useAuthState } from 'state/useAuthState';

type UseCanSendCriticalInitialReportProps = {
  isNewIncident: boolean;
  isModeratedSubmission: boolean;
  notificationType: NotificationType;
  isParent: boolean;
  reporterManaged: boolean;
};

export const useCanSendCriticalInitialReport = (
  props: UseCanSendCriticalInitialReportProps,
): boolean => {
  const {
    isNewIncident,
    isModeratedSubmission,
    notificationType,
    isParent,
    reporterManaged,
  } = props;
  const {
    permissions: { canSendCriticalAlerts },
  } = useAuthState();

  return (
    canSendCriticalAlerts &&
    isNewIncident &&
    !isModeratedSubmission &&
    !isParent &&
    reporterManaged &&
    notificationType === NotificationType.Normal
  );
};
